export default __webpack_public_path__ + "static/water-v2-5c24a2b4278ed6bcde41cfa1838d40fb.jpg";